module.exports = __webpack_public_path__ + "quotation.ddeae9e3.png";